import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const SmartDeliveryOptionIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="#000"
      d="M101.166 106.332c-1.254-2.508-.627-5.434 1.463-6.478-.627 0-1.254 0-1.881.417-2.09 1.045-2.926 3.971-1.672 6.479"
    />
    <path
      fill="url(#dhl__illustrations_smartdeliveryoptionillustration_svg_a)"
      d="m47.666 104.451 26.332-5.224L47.874 86.06l-26.54 5.224z"
      opacity={0.5}
    />
    <path fill="#FDDE84" d="m73.998 53.459 79.206-14.003-26.333-13.166-78.996 14.211z" />
    <path fill="#C39000" d="M73.998 53.459v45.768L47.874 86.06V40.5z" />
    <path fill="#FCCE09" d="M73.998 53.459v45.768l79.206-14.211v-45.56z" />
    <path fill="#000" d="M80.058 58.056v35.737l68.339-12.121V45.726z" />
    <path
      fill="url(#dhl__illustrations_smartdeliveryoptionillustration_svg_b)"
      d="m65.011 146.666 26.333-4.806-37.827-18.809-26.541 4.807z"
      opacity={0.5}
    />
    <path
      fill="url(#dhl__illustrations_smartdeliveryoptionillustration_svg_c)"
      d="m126.035 113.02 27.796-5.434-8.151-3.971-27.795 5.434z"
      opacity={0.5}
    />
    <path
      fill="#3A3A3A"
      d="m149.233 105.496 39.707-7.105c2.09-.418 3.553-2.3 3.553-4.389l2.09-76.698c-1.045-3.135-4.389-4.807-8.986-3.762l-35.946 6.479c-2.299.418-4.18 2.717-4.18 5.015v77.952s0 3.553 2.299 4.389c.836.418 2.09.418 3.135.418"
    />
    <path
      fill="#000"
      d="m191.239 100.69-39.707 7.105c-2.09.418-3.553-1.045-3.553-2.926V26.917c0-2.09 1.672-3.97 3.553-4.388l39.707-7.106c2.09-.418 3.553 1.045 3.553 2.926V96.3c0 2.09-1.463 4.18-3.553 4.389"
    />
    <path fill="#EFEFEF" d="m191.866 91.494-40.752 7.524-.209-67.294 40.752-7.315z" />
    <path fill="#1FC696" d="m163.653 96.719-12.539 2.299V66.625l12.539-2.09z" />
    <path fill="#FCCE09" d="m191.657 31.515-40.752 7.523v-7.314l40.752-7.315z" />
    <path fill="#fff" d="m191.657 63.281-40.543 7.315v-3.971l40.543-7.524z" />
    <path fill="#fff" d="m167.415 95.883-3.762.836V65.162l3.762-.627zM183.507 64.744l-3.762.627V33.814l3.553-.627z" />
    <path fill="#008CFF" d="m171.385 65.998-20.271 3.553V67.67l20.271-3.762z" />
    <path
      fill="#D40511"
      d="M171.386 49.07c-3.344.627-6.27 3.97-6.27 7.315 0 3.343 6.27 9.613 6.27 9.613s6.269-8.36 6.269-11.703c0-3.553-2.926-5.852-6.269-5.225m0 8.777c-1.463.21-2.508-.627-2.508-2.09s1.254-2.716 2.508-3.134c1.462-.21 2.507.627 2.507 2.09s-1.045 2.925-2.507 3.134"
    />
    <path
      fill="#4C4C4C"
      d="m68.982 105.914 1.881-.418s-.418.418-.836.418zM86.328 102.57l1.881-.418s-.418.418-.836.418z"
    />
    <path
      fill="#000"
      d="M85.701 109.049c-1.254-2.508-.627-5.434 1.463-6.479-.627 0-1.254 0-1.881.418-2.09 1.045-2.926 3.971-1.672 6.479M68.564 112.184c-1.254-2.508-.627-5.434 1.463-6.479-.627 0-1.254 0-1.88.418-2.09 1.045-2.927 3.971-1.673 6.479"
    />
    <path fill="#EFEFEF" d="m91.344 133.709 59.143-10.658-38.036-18.809L53.517 114.9z" />
    <path fill="#DD434C" d="m64.175 120.125 59.144-10.658-10.868-5.225L53.517 114.9z" />
    <path
      fill="#D3D3D3"
      d="m83.611 124.514 10.45-1.881-7.942-3.971-10.45 1.881zM93.434 129.948l10.658-1.881-7.942-3.762-10.658 1.881zM100.748 121.379l10.658-1.881-7.941-3.97-10.658 1.88zM110.57 127.022l10.659-2.09-7.942-3.762-10.658 1.881zM117.676 118.453l10.449-2.089-7.941-3.762-10.449 1.881zM127.498 123.887l10.659-1.881-7.942-3.971-10.658 1.881z"
    />
    <path
      fill="#000"
      d="M72.744 114.274c.836-.418 2.299-.418 3.344 0s1.045 1.045.209 1.254c-.836.418-2.3.418-3.344 0s-1.254-1.045-.21-1.254"
    />
    <path fill="#8E8E8E" d="M91.344 133.709v8.151l-37.827-18.809v-8.15z" />
    <path fill="#A00612" d="M64.175 120.125v8.151l-10.658-5.225v-8.15z" />
    <path fill="#D3D3D3" d="M91.344 133.709v8.151l59.143-10.659v-8.15z" />
    <path
      fill="#4C4C4C"
      d="M76.297 108.422c-1.254-2.508-3.971-3.762-6.06-2.717h-.21a5.28 5.28 0 0 1 4.18 3.135c1.254 2.508.418 5.434-1.672 6.479 0 0 1.045.627 2.717.418 1.045-.836 2.299-4.807 1.045-7.315"
    />
    <path
      fill="#000"
      d="M89.88 110.93c.837-.418 2.3-.418 3.345 0 .836.418 1.045 1.045.209 1.254-.836.418-2.3.418-3.344 0-1.045-.209-1.045-.836-.21-1.254"
    />
    <path
      fill="#4C4C4C"
      d="M93.434 105.287c-1.254-2.508-3.971-3.761-6.061-2.717h-.209a5.28 5.28 0 0 1 4.18 3.135c1.254 2.508.418 5.434-1.672 6.479 0 0 1.045.627 2.717.418 1.254-1.045 2.299-4.807 1.045-7.315M101.584 99.854l1.881-.418s-.418.417-.836.417z"
    />
    <path
      fill="#000"
      d="M105.346 108.213c.836-.418 2.299-.418 3.343 0 .836.418 1.045 1.045.209 1.254-.835.418-2.298.418-3.343 0-1.045-.209-1.045-.836-.209-1.254"
    />
    <path
      fill="#4C4C4C"
      d="M108.898 102.571c-1.253-2.508-3.97-3.762-6.06-2.717h-.209a5.29 5.29 0 0 1 4.18 3.134c1.254 2.508.418 5.434-1.672 6.479 0 0 1.045.627 2.717.418 1.253-1.045 2.298-4.807 1.044-7.314"
    />
    <path
      fill="#fff"
      d="M89.672 72.894V67.88l1.88-2.3v7.524l-.626.836zm1.88 2.3v7.523l-1.88-1.463v-5.225l1.254-1.463zM95.315 72.476v-7.523l1.88 1.463v5.016l-1.254 1.462zm1.88 2.3v5.015l-1.88 2.299v-7.524l.626-.836zm8.36-11.913-1.881 2.299-6.06 1.045-1.882-1.672zm0 17.764-10.032 1.672 1.881-2.3 6.061-1.044zm-1.672-9.614 1.045.837-1.045 1.044-6.688 1.254-.836-.836.836-1.045zm0-.627v-5.015l1.881-2.299v7.523l-.627.837zm1.881 2.3v7.523l-1.881-1.463V73.73l1.254-1.463zM109.108 67.043v-1.881l1.881-.418v1.88zm0 12.748V77.91l1.881-.418v1.88zM116.422 68.297l-1.254 1.463-.627-.627v-7.524l1.881 1.463zm0 8.15-1.881 2.299v-7.523l.627-.836 1.254 1.044zm8.36-16.928-1.881 2.3-6.061 1.044-1.881-1.672zm0 17.555-9.823 1.672 1.881-2.299 6.061-1.045zm.209-9.822-.627.836-1.254-1.045v-5.016l1.881-2.299zm0 9.404-1.881-1.463v-5.015l1.254-1.463.627.627zM128.125 66.625V59.1l1.881 1.463v5.016l-1.254 1.463zm10.241-9.614-1.881 2.3-6.061 1.044-1.881-1.672zm0 17.764-9.823 1.672 1.881-2.299 6.061-1.045zm-1.672-9.613 1.045.836-1.045 1.045-6.688 1.254-.836-.836.836-1.045zm2.09 1.672v7.523l-1.881-1.463V67.67l1.254-1.463z"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_smartdeliveryoptionillustration_svg_a"
        x1={42.272}
        x2={46.729}
        y1={98.15}
        y2={87.635}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_smartdeliveryoptionillustration_svg_b"
        x1={52.568}
        x2={58.486}
        y1={138.575}
        y2={125.283}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_smartdeliveryoptionillustration_svg_c"
        x1={132.177}
        x2={134.006}
        y1={109.797}
        y2={104.035}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
